import React from 'react';
import { motion } from 'framer-motion';

interface BudgetProps {
  totalBudget: number;
  remainingBudget: number;
  onComplete: () => void;
}

export const Budget: React.FC<BudgetProps> = ({
  totalBudget,
  remainingBudget,
  onComplete
}) => {
  const percentageUsed = ((totalBudget - remainingBudget) / totalBudget) * 100;

  return (
    <div className="bg-white/20 rounded-2xl p-6 space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-2">Art Market Stand Budget</h2>
        <p className="text-lg opacity-90">
          Set up your perfect art stand while staying within budget!
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <div className="flex justify-between mb-2">
            <span>Total Budget</span>
            <span className="font-bold">${totalBudget.toFixed(2)}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span>Remaining</span>
            <span className="font-bold">${remainingBudget.toFixed(2)}</span>
          </div>
        </div>

        <div className="h-4 bg-white/10 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-white"
            initial={{ width: 0 }}
            animate={{ width: `${percentageUsed}%` }}
            transition={{ duration: 0.5 }}
          />
        </div>

        <button
          onClick={onComplete}
          className="w-full bg-white text-[#4558C8] py-3 rounded-full font-bold hover:opacity-90 transition-opacity"
        >
          Complete Shopping
        </button>
      </div>
    </div>
  );
};